export const arrayCarouselWork = [
  {
    id: 1,
    title: "LombBnB",
    description: "Project Manager",
    icon: "/lombnb/logo.png",
    link: "https://github.com/project-bnb/project-bnb-reports",
    image: [
      "/lombnb/primo.png",
      "/lombnb/secondo.png",
      "/lombnb/terzo.png",
      "/lombnb/quarto.png",
      "/lombnb/quinto.png",
    ],
  },
  {
    id: 2,
    title: "Svgestor",
    description: "React Library",
    icon: "/svgestormaterial/svgestor-icon.png",
    link: "https://github.com/MindfulLearner/svgestor",
    image: [
      "/svgestormaterial/logofull.png",
      "/svgestormaterial/SVG-iconexampl.png",
      "/svgestormaterial/logofull.png",
    ],
  },
  {
    id: 3,
    title: "Prometheus",
    description: "Full Stack Developer",
    icon: "/prometheusmaterial/icon.svg",
    link: "https://github.com/prometheus-coding",
    image: [
      "/prometheusmaterial/Header.jpeg",
      "/prometheusmaterial/workwithus.jpeg",
    ],
    activeImage: false,
  },
  {
    id: 4,
    title: "DimaNet",
    description: "Server Infrastructure",
    icon: "icons/proxmox-icon.png",
    link: "https://github.com/MindfulLearner/dimaNet-homeLabServer",
    image: [
      "/proxmoxmaterial/Grub.png",
      "/proxmoxmaterial/DockerDontuse.png",
    "/proxmoxmaterial/archlinuxdesk.png",
      "/proxmoxmaterial/Server.png",
      "/proxmoxmaterial/VerticalScaling.png",
      "/proxmoxmaterial/VMARCH.png",
      "/proxmoxmaterial/distrocont.png",
    ],
  },
  {
    id: 5,
    title: "DimaFolio",
    description: "Portfolio",
    icon: "icons/react-icon.png",
    link: "https://github.com/MindfulLearner/dima-portfolio",
    image: [
      "/dimafoliomaterial/asd.png",
      "/dimafoliomaterial/port.png",
    ],
  },
  {
    id: 6,
    title: "Boolean",
    description: "Full Stack Developer",
    icon: "/icons/boolean-icon.png",
    link: "https://github.com/MindfulLearner/php-oop-2",
    image: [
      "/booleanmaterial/dropbox.png",
      "/booleanmaterial/layout.png",
      "/booleanmaterial/laravel1.png",
      "/booleanmaterial/dropbox1.png",
      "/booleanmaterial/laravel2.png",
      "/booleanmaterial/mysql1.png",
      "/booleanmaterial/project2.jpg",
    ],
    activeImage: false,
  },
  {
    id: 7,
    title: "Unieuro",
    description: "Manager",
    icon: "/icons/unieuro-icon.png",
    link: "https://www.unieuro.it/online/",
    image: [
      "/unieuromaterial/Unieuro-nuova-sede-e1637591871788.jpg",
      "/unieuromaterial/uneiruorinasce.jpeg",
    ],
    activeImage: false,
  },
  {
    id: 8,
    title: "McDonald",
    description: "Crew Member",
    icon: "/icons/mcdonald-icon.png",
    link: "https://www.mcdonalds.it/",
    image: [
      "/macdonaldmaterial/greendon.jpg",
      "/macdonaldmaterial/mcpata.jpg",
    ],
    activeImage: false,
  },
];
export default arrayCarouselWork;